import FactorSelection from "./FactorSelection";
import BaseFactor from "@/types/Config/Factor";

/** Type Facteur d'influence spécifique à la fonction Benchmarking */
export default class Factor extends BaseFactor {
    constructor(id: string) {
        super(id);
    }

    Selections : FactorSelection[] = [];
}